import {
	Component,
	ContentChild,
	Input,
	OnDestroy,
	OnInit,
	signal,
	TemplateRef,
	ViewEncapsulation,
	WritableSignal,
} from '@angular/core';
import { Location } from '@angular/common';

interface Scope {
	loading: WritableSignal<boolean>;
}

@Component({
	selector: 'ms-content-form',
	templateUrl: './ms-content-form.component.html',
	styleUrls: ['./ms-content-form.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsContentFormComponent implements OnInit, OnDestroy {
	@Input() header: string = '';
	@ContentChild('headerRightTemplate') headerRightTemplate: TemplateRef<any>;
	@ContentChild('footerRightTemplate') footerRightTemplate: TemplateRef<any>;

	scope: Scope = {
		loading: signal(true),
	};

	/**
	 * Constructor
	 */
	constructor(private _location: Location) {}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.scope.loading.set(false);
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	onGoBack(): void {
		this._location.back();
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
